import type { NDateLocale } from './enUS'
import { sk } from 'date-fns/locale'

const dateSkSK: NDateLocale = {
  name: 'sk-SK',
  locale: sk
}

export default dateSkSK
